import React, { Component } from "react";
import moment from "moment";
// import { ddmmyyyy } from "../helpers/dateType";
import $ from "jquery";
import "react-bootstrap-daterangepicker";

const defaultPickerOptions = {
  locale: {
    format: "DD.MM.YYYY",
    separator: " - ",
    applyLabel: "Применить",
    cancelLabel: "Отмена",
    fromLabel: "От",
    toLabel: "До",
    customRangeLabel: "Свой",
    daysOfWeek: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    monthNames: [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь"
    ],
    firstDay: 1
  },
  showDropdowns: true
};

const RANGE_TODAY = "Сегодня";
const RANGE_YESTERDAY = "Вчера";
const RANGE_LAST_WEEK = "Последние 7 дней";
const RANGE_LAST_MONTH = "Последние 30 дней";
const RANGE_THIS_MONTH = "Этот месяц";
const RANGE_PREV_MONTH = "Прошлый месяц";
const RANGE_MAY = "МАЙ (тестирование)";

export default class DateRange extends Component {
  pickerCallback = (start, end) =>
    $("#reportrange span").html(
      start.format("D MMMM YYYY") + " - " + end.format("D MMMM YYYY")
    );

  makeRanges = () => {
    let dates = {
      [RANGE_TODAY]: [moment(), moment()],
      [RANGE_YESTERDAY]: [
        moment().subtract(1, "days"),
        moment().subtract(1, "days")
      ],
    };

    if (!this.props.singleDatePicker) {
      Object.assign(dates, {
        [RANGE_LAST_WEEK]: [moment().subtract(6, "days"), moment()],
        [RANGE_LAST_MONTH]: [moment().subtract(29, "days"), moment()],
        [RANGE_THIS_MONTH]: [moment().startOf("month"), moment().endOf("month")],
        [RANGE_PREV_MONTH]: [
          moment()
            .subtract(1, "month")
            .startOf("month"),
          moment()
            .subtract(1, "month")
            .endOf("month")
        ],
        [RANGE_MAY]: [
          moment("01.05.2018", "DD.MM.YYYY"),
          moment("31.05.2018", "DD.MM.YYYY")
        ]
      })
    }

    return dates;
  };

  onApply = (ev, picker) => {
    const startDate = moment().subtract(29, "days");
    const endDate = moment();
    let time = this.props.singleDatePicker ? "" : startDate + "-" + endDate;
    if (!this.props.singleDatePicker) {
      time =
        picker.startDate.format("DD.MM.YYYY") +
        "-" +
        picker.endDate.format("DD.MM.YYYY");
    } else {
      time = picker.startDate.format("DD.MM.YYYY");
    }
    if (this.props.onChangeDateRange) {
      this.props.onChangeDateRange(time);
    } else if (this.props.onChange) {
      this.props.onChange({
        startDate: picker.startDate.toDate(),
        endDate: picker.endDate.toDate()
      });
    }
  };

  singlePickerInit = () => {
    // console.log(dateBegin)
    const { dateBegin } = this.props;
    const startDate = moment(dateBegin);
    const picker = this.range.data("daterangepicker");
    picker.setStartDate(startDate);
    picker.setEndDate(startDate);
  };

  rangePickerInit = () => {
    const { dateBegin, dateEnd } = this.props;
    const [startDate, endDate] =
      dateBegin && dateEnd
        ? [moment(dateBegin), moment(dateEnd)]
        : [moment().subtract(7, "days"), moment()];

    const picker = this.range.data("daterangepicker");
    picker.setStartDate(startDate);
    picker.setEndDate(endDate);
  };

  componentWillUnmount() {
    $(this.refs.range).daterangepicker("destroy");
  }

  componentDidUpdate() {
    (this.props.singleDatePicker
      ? this.singlePickerInit
      : this.rangePickerInit)();
  }

  componentDidMount() {
    if (this.refs.range) {
      const { dateBegin, dateEnd, singleDatePicker } = this.props;
      const [startDate, endDate] =
        dateBegin && dateEnd
          ? [moment(singleDatePicker ? dateBegin : dateEnd), moment(dateEnd)]
          : [moment().subtract(7, "days"), moment()];

      this.range = $(this.refs.range);
      this.range.daterangepicker(
        {
          ...defaultPickerOptions,
          singleDatePicker,
          ranges: this.makeRanges()
        },
        this.pickerCallback
      );
      this.range.on("apply.daterangepicker", this.onApply);
      this.pickerCallback(startDate, endDate);
      this.componentDidUpdate();
    }
  }

  render() {
    return (
      <div>
        <input
          type="text"
          id="dateRangePicker"
          readOnly
          className={this.props.className + " dateRange"}
          ref="range"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/DateRange.jsx